import React from 'react';
import {
  UserRound,
  CalendarClock,
  MessagesSquare,
  Globe2,
  Heart,
  Sparkles
} from 'lucide-react';
import { whyStudentsData } from '../mock/programsData';

const iconMap = {
  UserRound,
  CalendarClock,
  MessagesSquare,
  Globe2,
  Heart,
  Sparkles
};

const palette = [
  { bg: 'from-pink-100 to-pink-50', border: 'border-pink-300', icon: 'text-pink-600', chip: 'from-pink-200 to-pink-300' },
  { bg: 'from-purple-100 to-purple-50', border: 'border-purple-300', icon: 'text-purple-600', chip: 'from-purple-200 to-purple-300' },
  { bg: 'from-blue-100 to-blue-50', border: 'border-blue-300', icon: 'text-blue-600', chip: 'from-blue-200 to-blue-300' },
  { bg: 'from-yellow-100 to-yellow-50', border: 'border-yellow-300', icon: 'text-yellow-600', chip: 'from-yellow-200 to-yellow-300' },
  { bg: 'from-green-100 to-green-50', border: 'border-green-300', icon: 'text-green-600', chip: 'from-green-200 to-green-300' },
  { bg: 'from-pink-100 to-purple-50', border: 'border-purple-300', icon: 'text-purple-600', chip: 'from-pink-200 to-purple-200' }
];

const WhyStudents = () => {
  return (
    <section
      id="why-students"
      data-testid="why-students-section"
      className="py-20 bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold text-purple-600 mb-4">
            {whyStudentsData.title}
          </h2>
          <p className="text-base md:text-lg text-purple-600 max-w-2xl mx-auto">
            {whyStudentsData.subtitle}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {whyStudentsData.benefits.map((b, i) => {
            const Icon = iconMap[b.icon] || Sparkles;
            const c = palette[i % palette.length];
            return (
              <div
                key={b.title}
                data-testid={`why-card-${i}`}
                className={`bg-gradient-to-br ${c.bg} border-3 ${c.border} rounded-3xl p-7 hover:shadow-xl hover:scale-[1.02] transition-all duration-300`}
              >
                <div className={`w-14 h-14 bg-gradient-to-br ${c.chip} rounded-2xl flex items-center justify-center mb-5`}>
                  <Icon className={`h-7 w-7 ${c.icon}`} />
                </div>
                <h3 className="text-xl font-bold text-purple-700 mb-2">
                  {b.title}
                </h3>
                <p className="text-sm text-gray-700 leading-relaxed">
                  {b.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyStudents;
